import { Button, Card, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { gradientBrand, passtrackColors } from "../theme";
import { useAuth } from "../routing/AuthContext";
import {
  EntryLogo,
  EntryShell,
  entryMenuCardSx,
} from "../routing/entryShell";
import { ROUTES } from "../routing/paths";

const primaryButtonSx = {
  py: 1.4,
  fontWeight: 700,
  backgroundImage: gradientBrand,
  "&:hover": {
    backgroundImage: gradientBrand,
    filter: "brightness(0.95)",
  },
} as const;

export default function MenuPage() {
  const navigate = useNavigate();
  const { session, properties, logout } = useAuth();

  const handleLogout = () => {
    logout();
    navigate(ROUTES.login, { replace: true });
  };

  if (properties.length === 0) {
    navigate(ROUTES.setupNew, { replace: true });
    return null;
  }

  return (
    <EntryShell>
      <Card variant="outlined" sx={entryMenuCardSx}>
        <EntryLogo />
        <Typography
          sx={{
            fontSize: 12,
            fontWeight: 700,
            letterSpacing: "0.18em",
            textTransform: "uppercase",
            color: passtrackColors.blue,
            mb: 1.5,
          }}
        >
          Control de acceso
        </Typography>
        <Typography
          sx={{
            fontWeight: 700,
            fontSize: { xs: 26, sm: 28 },
            lineHeight: 1.2,
            color: passtrackColors.ink,
            mb: 1,
          }}
        >
          Setup de Propiedad
        </Typography>
        <Typography
          sx={{
            fontSize: 14,
            lineHeight: 1.5,
            color: passtrackColors.textMuted,
            mb: 4,
          }}
        >
          Hola, {session?.user.name || session?.user.email}. ¿Qué deseas hacer?
        </Typography>

        <Button
          variant="outlined"
          fullWidth
          onClick={() => navigate(ROUTES.selectProperty)}
          sx={{
            py: 1.4,
            mb: 1.5,
            fontWeight: 700,
            borderColor: passtrackColors.borderDefault,
            color: passtrackColors.ink,
            "&:hover": {
              borderColor: passtrackColors.blue,
              background: passtrackColors.cloud,
            },
          }}
        >
          Editar propiedad
        </Button>
        <Button
          variant="contained"
          fullWidth
          onClick={() => navigate(ROUTES.setupNew)}
          sx={{ ...primaryButtonSx, mb: 1 }}
        >
          Nueva propiedad
        </Button>
        <Button
          variant="text"
          fullWidth
          onClick={handleLogout}
          sx={{ color: passtrackColors.textMuted, fontWeight: 600 }}
        >
          Cerrar sesión
        </Button>
      </Card>
    </EntryShell>
  );
}
